import { AfterEventActionsConfig, TreeButtonsConfig, TreeTogglesConfig } from "./config-schema"
import { CodeEditor } from "@/components/editor/code-editor"

export function CreateExampleConfigHelp(example: any) {
  return function ExampleConfigHelp() {
    return (
      <div>
        <h1 className="mb-2">Example configuration</h1>
        <CodeEditor mode="json" value={JSON.stringify(example, null, 4)} />
      </div>
    )
  }
}

export const REPARENT_ACTION_EXAMPLE: AfterEventActionsConfig = [
  {
    "type": "start-rule",
    "startRule": "post-reparent-rule",
    "parameters": {
      "nodeUri": "{{node_uri}}",
      "prevParentUri": "{{node_prevParentUri}}",
      "nextParentUri": "{{node_nextParentUri}}"
    }
  }
]

export const REORDER_ACTION_EXAMPLE: AfterEventActionsConfig = [
  {
    "type": "start-rule",
    "startRule": "post-reorder-rule",
    "parameters": {
      "sourceUri": "{{node_uri}}",
      "targetUri": "{{targetNode_uri}}",
      "reorderType": "{{reorder}}"
    }
  }
]

export const TOGGLES_EXAMPLE: TreeTogglesConfig = [
  {
    "id": "ghost",
    "topic": "ghostedModels",
    "subscription": "ghostedModels",
    "iconOn": "lucide-ghost",
    "tooltipOn": "Ghosted. Click to show normally.",
    "tooltipOff": "Shown normally. Click to ghost."
  },
  {
    "id": "pin",
    "topic": "pinnedModels",
    "subscription": "pinnedModels",
    "iconOn": "lucide-pin",
    "iconOff": "lucide-pin-off",
    "colorOn": "#ee3399",
    "colorOff": "#9ca3af",
    "tooltipOn": "Pinned. Click to unpin.",
    "tooltipOff": "Not pinned. Click to pin."
  }
]

export const BUTTON_EXAMPLE: TreeButtonsConfig = {
  noRow: [
    {
      "icon": "lucide-plus",
      "label": "Add new root node",
      "actions": [{ "type": "start-add-root-node" }]
    },
    { "spacer": true },
    {
      "buttons": [
        {
          "icon": "lucide-gem",
          "label": "do something special",
          actions: [
            {
              "type": "start-rule",
              "startRule": "post-delete-rule",
              "parameters": {
                "target": "{{currentTarget}}"
              }
            }
          ],
        },
      ]
    }
  ],
  perRow: [
    {
      "icon": "lucide-pencil",
      "label": "Edit node",
      "actions": [
        {
          "type": "start-edit-node",
          "onSuccess": [
            {
              "type": "publish",
              "topic": "lastEditedNode",
              "value": "{{node_uri}}",
              "notification": {
                "onSuccess": "Node edited successfully"
              }
            }
          ],
          "onUriRenamed": [
            {
              "type": "start-rule",
              "startRule": "post-uri-rename-rule",
              "parameters": {
                "prevUri": "{{prevNode_uri}}",
                "nextUri": "{{nextNode_uri}}"
              }
            }
          ]
        }
      ]
    },
    {
      "buttons": [
        {
          "icon": "lucide-plus",
          "label": "Add child",
          "actions": [
            {
              "type": "start-add-node",
              "parent": "{{node_uri}}"
            }
          ]
        },
        {
          "label": "Add sibling",
          "disabled": "false",
          "actions": [
            {
              "type": "start-add-node",
              "parent": "{{node_parentUri}}"
            }
          ]
        },
        { "separator": true },
        {
          "icon": "lucide-trash",
          "label": "Delete node",
          "actions": [
            {
              "type": "send-delete-node-request",
              "onSuccess": [
                {
                  "type": "start-rule",
                  "startRule": "post-delete-rule",
                  "parameters": {
                    "nodeUri": "{{node_uri}}"
                  }
                }
              ]
            }
          ],
          "disabled": "{{node_hasChildren}}",
          "confirmation": {
            "message": "Are you sure you want to delete this node?"
          }
        },
        { "separator": true },
        {
          "icon": "lucide-download",
          "label": "download",
          "actions": [
            {
              "type": "fetch-file",
              "url": "/servlets/cgi/download/{{somethingFromUploadAnyFile}}",
              "desiredFilename": "something.ttl"
            }
          ]
        },
      ]
    }
  ],
}
